import React, { useState, useCallback } from "react";
import Chance from "chance";
import { Header, Subsection, DataPageContainer, FooterLinks } from "../components";
import FsLightbox from "fslightbox-react";
import Gallery from "react-photo-gallery";
import photoDimensionData from "../data/photo_data.json";

function importAll(r) {
  return r.keys().map((item) => ({ name: item.substring(2), src: r(item) })); //.substring(2) just removes the "./"
}

const chance = new Chance(0);
const photos = importAll(
  require.context("../img/photo_page", false, /\.(jpe?g|JPE?G)$/)
).filter((photo) => photo.name in photoDimensionData);

const thumbnails = importAll(
  require.context("../img/photo_page/thumbnails", false, /\.(jpe?g|JPE?G)$/)
).filter((photo) => photo.name in photoDimensionData);

const photosData = chance.shuffle(
  photos.map((photo, index) => {
    return {
      src: photo.src,
      width: photoDimensionData[photo.name].width,
      height: photoDimensionData[photo.name].height,
      thumbnail: thumbnails[index].src,
    };
  })
);

const lightboxPhotoData = photosData.map((photo) => photo.src);
const galleryPhotoData = photosData.map((photo) => ({
  src: photo.thumbnail,
  width: photo.width,
  height: photo.height,
}));

// If you're adding/deleting photos uncomment this for a second to check you added/deleted both the thumbnail and the original photo

// function testPhotosMatch() {
//   const thumbnailNames = thumbnails.map((photo) => photo.name).join(",");
//   const photoNames = photos.map((photo) => photo.name).join(",");
//   if (thumbnailNames === photoNames) {
//     console.log("All good, photos match");
//   } else {
//     console.error(
//       "Photo exists as thumbnail but not full sized or vice versa. Or the names are different"
//     );
//   }
// }
// testPhotosMatch();

function Photos() {
  const [toggler, setToggler] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(null);

  const openLightbox = useCallback(
    (event, { photo, index }) => {
      setPhotoIndex(index);
      setToggler(!toggler);
    },
    [toggler]
  );

  return (
    <DataPageContainer>
      <Header>Photo Gallery</Header>
      <Subsection>
        Want to submit more photos? Reach out to us using the Feedback Form. {"\n"}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="          https://forms.gle/cBTjXcmJqSgj3f3n9
            "
          >
            Feedback Submission Form
          </a>.  {"\n\n"}
      </Subsection>

      <div className="PhotoGalleryContainer">
        <Gallery
          photos={galleryPhotoData}
          direction={"column"}
          onClick={openLightbox}
          margin={3}
        />
      </div>
      <FsLightbox
        toggler={toggler}
        sources={lightboxPhotoData}
        sourceIndex={photoIndex}
      />
      <FooterLinks
        back={{ text: "view advice & conclusions", to: "advice-conclusions" }}
      />
    </DataPageContainer>
  );
}

export default Photos;
